import React, { useState } from 'react';
import Button from '../Button';
import SystemToast from '../SystemToast';
import { raiseToast, TOAST_POSITION } from '../Toaster';

interface InvoicePdfRegenerationWarningProps {
  invoiceNumber: number | string;
  orderNumber: number | string;
  onRetry: () => Promise<unknown>;
  onSuccess: () => void;
}

export default function InvoicePdfRegenerationWarning({
  invoiceNumber,
  orderNumber,
  onRetry,
  onSuccess,
}: InvoicePdfRegenerationWarningProps) {
  const [isRetrying, setIsRetrying] = useState(false);
  const [retryFailed, setRetryFailed] = useState(false);

  const retryPdfRegeneration = async () => {
    setIsRetrying(true);
    setRetryFailed(false);

    try {
      await onRetry();
      onSuccess();
      raiseToast(
        <SystemToast type={SystemToast.Type.SUCCESS} message={`PDF for Invoice #${invoiceNumber} refreshed`} />,
        { position: TOAST_POSITION.BOTTOM_LEFT },
      );
    } catch (err) {
      setRetryFailed(true);
      console.error('Failed to retry invoice PDF regeneration after void', err);
    } finally {
      setIsRetrying(false);
    }
  };

  return (
    <SystemToast
      type={SystemToast.Type.WARN}
      message={`Invoice for Order #${orderNumber} was voided, but its PDF could not be refreshed. ${
        retryFailed ? 'The retry failed. ' : ''
      }Retry to replace the existing PDF.`}
    >
      <Button disabled={isRetrying} loading={isRetrying} label="Retry PDF" theme="1" onClick={retryPdfRegeneration} />
    </SystemToast>
  );
}